/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 10.09.17.
 */

import React from "react";
import _ from "underscore";
import BaseResourceContainer from "./BaseResourceContainer";
import {removeStore} from "../../services/Dynamic";

class TempResourceContainer extends BaseResourceContainer {
    getStoreName(resource) {
        if (!this.storeName) this.storeName = _.uniqueId("TempResourceContainer");
        return this.storeName;
    }

    unloadStores() {
        super.unloadStores();
        if (this.storeName) removeStore(this.storeName);
    }

}

export default TempResourceContainer;
